import { sanitizeValue } from '@helsenorge/core-cms/userfeedback/utils/string';
import { post, patch } from '@helsenorge/framework-utils/cms-content-api-service';
export const createFeedback = async (body) => {
    return post(`usertjenestefeedback`, body);
};
export const updateFeedback = async (body) => {
    const sanitized = { id: body.id, score: body.score, comment: body.comment && sanitizeValue(body.comment) };
    return patch(`usertjenestefeedback`, sanitized);
};
